<script>
  export default {
    data () {
      return {
        waiting: false,
      }
    },
    computed: {
      showLoadingIndicator () {
        return this.loading || this.waiting
      },
    },
    watch: {
      loading (newVal, oldVal) {
        // If it wasn't loading, but now it is loading
        if (oldVal === false && newVal === true) {
          // This is the variable used for delaying the loading UI
          this.waiting = true

          this.loadingDelayTimeout = setTimeout(() => {
            this.waiting = false
          }, this.loadingDelayMs)
        }
      },
    },
    props: {
      loading: {
        type: Boolean,
        required: true,
      },
      loadingDelayMs: {
        type: Number,
        default: 1000,
      },
    },
  }
</script>
